/**
 * returns the corresponding value to a configured coordinate
 * the values for dimensions must be arrays of type Dependency
 * or a Number for static values
 * @see Dependency
 * @see TerracePlanner
 *
 * @param dimensions Dependency[] | Number
 * @returns Number
 */
export function getCoordinateValue(dimensions) {
    if ('number' === typeof dimensions) {
        return dimensions;
    }

    return dimensions.reduce(reduceDimensions, 0);
}

/**
 * callback for Array.prototype.reduce
 * adds the value of the input Element with id === currentValue.dimension to the accumulator
 *
 * @param accumulator Number
 * @param currentValue Dependency
 * @returns Number
 */
function reduceDimensions(accumulator, currentValue) {
    return accumulator + Number(document.getElementById(currentValue.dimension).value.replace(',', '.')) / currentValue.factor;
}